import { render } from "./FeaturesOverview.vue?vue&type=template&id=bc21e622"
import script from "./FeaturesOverview.vue?vue&type=script&lang=js"
export * from "./FeaturesOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__